export type PaymentPlanValues =
  | 'BUYSIDE_PRO'
  | 'RETAIL_TIER_1'
  | 'RETAIL_TIER_1_MONTHLY'
  | 'RETAIL_TIER_2'
  | 'RETAIL_TIER_3'
  | 'EVENT';
export type IntervalType = 'Per Year' | 'Per Bundle' | 'Per Month';
export interface PaymentPlanInfo {
  prices: {
    interval: IntervalType;
    intervalBadge?: string;
    price: number;
    stripePlan: PaymentPlanValues;
  }[];
  sellingPoints: Array<{ [key: string]: string[] }>;
  title: string;
}

export const stripePlans: { [K in 'buyside' | 'retail']: PaymentPlanInfo[] } = {
  buyside: [
    {
      title: 'PRO',
      prices: [
        {
          interval: 'Per Year',
          price: 7500,
          stripePlan: 'BUYSIDE_PRO'
        }
      ],
      sellingPoints: [
        {
          'Research By The Buyside. For The Buyside.': [
            'Get direct access to research from your peers with skin in the game',
            'Strengthen your holdings with in-depth analysis on thousands of new investment ideas a year',
            'Unlock thousands of custom models, channel checks, and more'
          ]
        },
        {
          'Find Exactly What You Need, When You Need It': [
            'Cut through the noise and unlock actionable ideas with custom alerts',
            'Get insights into risks and returns through thoughtful commentary and analysis',
            'See what other investors are saying about trending stocks with our consensus data',
            'Assess research based on actual returns, not hype'
          ]
        },
        {
          "Discover the Financial World's Top Alpha Generators": [
            "Grow your portfolio while tracking your peers that continually outperform the market in SumZero's fully transparent network",
            'Develop new investment strategies based on top fund moneymakers'
          ]
        },
        {
          'Networking Opportunities': [
            'Connect directly with hiring managers and seize opportunities for career growth',
            'Discuss top research ideas in a professional, engaging environment',
            'Empower your professional potential by posting investment ideas'
          ]
        }
      ]
    }
  ],
  retail: [
    // {
    //   title: 'EVENT',
    //   prices: [{ price: 200, interval: "Per Bundle", stripePlan: "EVENT" }],
    //   sellingPoints: []
    // },
    {
      title: 'LITE',
      prices: [
        {
          interval: 'Per Bundle',
          price: 350,
          stripePlan: 'RETAIL_TIER_3'
        }
      ],
      sellingPoints: [
        {
          'Pay As You Go': [
            '5 pre-paid credits that never expire.',
            'Use one credit per idea to gain access to the full report.',
            'Add more credits at any time.',
            'The 45-day delayed access still applies.'
          ]
        }
      ]
    },
    {
      title: 'PREMIUM',
      prices: [
        {
          interval: 'Per Bundle',
          price: 1500,
          stripePlan: 'RETAIL_TIER_2'
        }
      ],
      sellingPoints: [
        {
          'Pay As You Go': [
            '35 pre-paid credits that never expire.',
            'Use one credit per idea to gain access to the full report.',
            'Add more credits at any time.',
            'The 45-day delayed access still applies.'
          ]
        }
      ]
    },
    {
      title: 'ELITE',
      prices: [
        {
          interval: 'Per Year',
          intervalBadge: 'Save 22%',
          price: 7500,
          stripePlan: 'RETAIL_TIER_1'
        },
        {
          interval: 'Per Month',
          price: 800,
          stripePlan: 'RETAIL_TIER_1_MONTHLY'
        }
      ],
      sellingPoints: [
        {
          Subscription: [
            'Comprehensive access to the entire research database.',
            'Special offers and exclusive features only available for buyside and Elite members.',
            'Real-time access without delay.'
          ]
        }
      ]
    }
  ]
};
